import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficeUserAgentRequest = (personId) => {
  return http.get(
    `${getBaseUrl()}/back_office_user_agent_request/${personId}`,
  );
};

export const submitBackOfficeAgentRequest = data => {

  return http.post(
    `${getBaseUrl()}/back_office_user_agent_request`,
    data
  );
};

export const updateBackOfficeAgentRequestPersonalInfo = data => {
  return http.put(
    `${getBaseUrl()}/back_office_agent_request_personal_info/${data.id}`,
    data
  );
};

export const updateBackOfficeAgentRequestContactInfo = data => {
  return http.put(
    `${getBaseUrl()}/back_office_agent_request_contact_info/${data.id}`,
    data
  );
};

export const updateBackOfficeAgentRequestExpertInfo = data => {


  return http.put(
    `${getBaseUrl()}/back_office_agent_request_expert_info/${data.agent_request.id}`,
    data
  );
};

export const updateBackOfficeAgentRequestFile = data => {

  http.hasFile();
  return http.put(
    `${getBaseUrl()}/back_office_agent_request_file/${data.id}`,
    data
  );
};